import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

  columnas: number = 6;
  colspanImg: number = 3;
  colspanError: number = 3;
  columnaOculta: boolean = false;

  customPage = [
    {
      key: "/notfound",
      numberError: "404",
      longText: "Lo sentimos, pero la página que buscas no existe.",
      otherText: ""
    },
    {
      key: "/errorcompatibility",
      numberError: "",
      longText: "Browser no compatible.",
      otherText: "Para una mejor navegación, recomendamos los siguientes navegadores: Chrome, Firexfox, Safari o Edge."
    }
  ];

  data: any;

  constructor(private router: Router) { }

  ngOnInit() {

    if (window.innerWidth <= 720) {
      this.columnas = 1;
      this.colspanImg = 1;
      this.colspanError = 1;
      this.columnaOculta = true;
    } else {
      this.columnas = 6;
      this.colspanImg = 3;
      this.colspanError = 3;
      this.columnaOculta = false;
    }

    let url = this.router.url;
    this.data = this.customPage.find(x => x.key == url);
  }

  onResize(event: any) {
    if (event.target.innerWidth <= 720) {
      this.columnas = 1;
      this.colspanImg = 1;
      this.colspanError = 1;
      this.columnaOculta = true;
    } else {
      this.columnas = 6;
      this.colspanImg = 3;
      this.colspanError = 3;
      this.columnaOculta = false;
    }
  }
}
